module.exports = __webpack_public_path__ + "static/media/icon-lap-3L.bc1e8891.svg";